import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'

const MemberCard = ({
  id,
  name,
  role,
  createdAt,
  picture,
  showUserModal,
  mimeType,
  originalTag,
  isOriginal,
  className
}) => {
  const [decryptedImage, setDecryptedImage] = useState('')
  useEffect(() => {
    if (picture) {
      getDescryptedMedia(picture, isOriginal, originalTag, mimeType, id, true).then((data) =>
        setDecryptedImage(data.img)
      )
    }
  }, [picture])

  return (
    <button className={`${styles.memberCardWrapper} ${className}`} onClick={showUserModal}>
      <img src={decryptedImage} alt={name} className={styles.picture} />
      <div className={styles.name}>{name}</div>
      {role && <div className={styles.role}>{role}</div>}
      {createdAt && <div className={styles.createdAt}>{createdAt}</div>}
    </button>
  )
}

MemberCard.propTypes = {
  name: PropTypes.string,
  role: PropTypes.string,
  createdAt: PropTypes.string,
  picture: PropTypes.string
}

export default MemberCard
